export const DEFAULT_DELETE_CONFIRM_TEXT = 'Данное действие невозможно отменить. Удалить сущность?';
export const DEFAULT_DELETE_ELEMENT_CONFIRM_TEXT = 'Вы уверены, что хотите удалить документ/запись?';
export const DEFAULT_CLEAR_ELEMENT_CONFIRM_TEXT = 'Вы уверены, что хотите очистить выбранные записи?';

export enum EBUTTONDELETETYPE {
    CLEAR = 'Очистить',
    DELETE = 'Удалить выбранное'
}
